import * as React from "react";
export default function TestimonianzeDiDolcezza() {
  return <section id="testimonianze-di-dolcezza" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground tracking-tight">
            Dicono di Noi
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">Le parole di chi ha assaporato la nostra passione e la tradizione della pasticceria siciliana.<br /><br /><br /></p>
        </div>

        <div className="w-full max-w-6xl mx-auto px-4 md:px-12">
          [grw id=322]
        </div>
      </div>
    </section>;
}